<template>
  <div id="toasts">
    <transition-group name="toast">
      <AppToast v-for="(toast, i) in toasts" :toast="toast" :key="toast.key"
        :style="`opacity:${1 - i * 0.33};z-index:${-i+1};transform: scale(${1 - i * 0.05}) translateY(${1 + i * 10}px)`"
        @click="store.global.removeToast(i)"
      />
    </transition-group>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppToast from './AppToast.vue'
import { store } from '@/store'

export default defineComponent({
  name: 'AppToasts',
  components: { AppToast },
  setup() {
    store.global.mutate(state => state.toasts = [])
    const toasts = store.global.get(state => state.toasts)

    return { store, toasts }
  }
})
</script>

<style lang="scss" scoped>
#toasts {
  position: fixed;
  z-index: 100000000;
  top: .5rem;
  right: .5rem;
  left: .5rem;
}

.toast-enter-active, .toast-leave-active {
  transition: transform .3s, opacity .3s;
}
.toast-enter-from, .toast-leave-to {
  transform: translateY(-8rem) !important;
  z-index: 100000 !important;
}

@media only screen and (max-width: 480px) {
  #toasts {
    top: unset;
    bottom: calc(5rem + var(--margin-bottom));
  }
  .toast-enter-from, .toast-leave-to {
    transform: translateY(8rem) !important;
  }
}
</style>